// /api/agent/gateway の要求のパス。画面が URL を組み立てるときに使う（BE のルーターは express のパスの文字列で登録する）
const GATEWAY_PATH = '/api/agent/gateway'

interface SessionPathParameters {
  // storage が振ったセッションの ID
  agentSessionId: string
}

interface TurnPathParameters extends SessionPathParameters {
  // BE が run で振ったターンの ID
  turnId: string
}

// セッションの作成（POST /api/agent/gateway/sessions）
export const sessionsPath = (): string => `${GATEWAY_PATH}/sessions`

// 指示の送信（POST .../sessions/{agentSessionId}/turns）
export const turnsPath = ({ agentSessionId }: SessionPathParameters): string =>
  `${sessionsPath()}/${agentSessionId}/turns`

// ターンの下の途中からの配信（GET .../stream）と中断（POST .../cancel）
export const turnActionPath = (parameters: TurnPathParameters, action: 'stream' | 'cancel'): string =>
  `${turnsPath(parameters)}/${parameters.turnId}/${action}`

// 承認への回答（POST .../turns/{turnId}/approvals/{approvalId}）。approvalId は runtime が run の SSE の approval_request で振ったもの
export const approvalPath = (parameters: TurnPathParameters & { approvalId: string }): string =>
  `${turnsPath(parameters)}/${parameters.turnId}/approvals/${parameters.approvalId}`
